import LucaFanitinCooking from "../../../assets/chef_creating_a_new_beginning.jpg"
import { getArray } from "../../../utils/helpers"

const NewBeginning = ({t}) => {

    const exploreMore = () => {
        window.scrollTo(0, 0);
        const url = `/services`;
        window.location.href = url;
    }

    return (
        <section className="py-12 bg-white mx-auto">
            <div className="container mx-auto px-4 max-w-[1200px]">
                <div className="flex flex-col md:flex-row gap-8">
                    {/* Left Column */}
                    <div className="md:w-1/2 relative">
                        <div className="relative">
                            <img
                                src={LucaFanitinCooking}
                                alt="Chef decorating carrots"
                                className="w-[100%] h-auto"
                            />
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="md:w-1/2 flex flex-col justify-center pl-10">
                        <h5 className="text-[#C7702A] uppercase mb-2 font-['Jost',sans-serif] text-[15px] font-normal">{t?.title}</h5>
                        <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[30px] font-medium tracking-[-0.6px] leading-[48px] ">{t?.subTitle}</h2>
                        <ul className="space-y-4 mb-8">
                            {getArray(t?.lists).map((item, index) => (
                                <li key={index} className="flex items-start">
                                    <span className="text-[#C7702A] text-primary-500 mr-2">■</span>
                                    <span className="text-[rgba(31,7,7,0.62)] font-['__Jost_461405'] text-[18px] font-normal leading-[28.8px]">{item}</span>
                                </li>
                            ))}
                        </ul>
                        <button
                            onClick={exploreMore}
                            className="w-1/3 border py-2 px-4 rounded-md transition duration-300 font-semibold flex justify-center"
                            style={{
                                borderColor: 'rgb(211, 117, 43)',
                                color: 'rgb(211, 117, 43)',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgb(211, 117, 43)';
                                e.currentTarget.style.color = 'white';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                                e.currentTarget.style.color = 'rgb(211, 117, 43)';
                            }}
                        >
                            {t?.link}
                        </button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default NewBeginning;
